export const ds_ButtonGroupBlock_Entry = `
    fragment ds_ButtonGroupBlock_Entry on ds_ButtonGroupBlock_Entry {
        id
        canonicalUid
        buttonGroup_ColorPalette
        buttonGroup_ColorTheme
        buttonGroup_TopSpacing
        buttonGroup_ContainerWidth
        buttonGroup_FullWidthBackground

        buttonGroup_Alignment

        buttonGroup_Buttons {
            text
            target
            title
            url
            ariaLabel
            ... on buttonGroup_Buttons_Custom_LinkType {
                buttonStyle
            }
            ... on buttonGroup_Buttons_Entry_LinkType {
                buttonStyle
            }
            ... on buttonGroup_Buttons_Url_LinkType {
                buttonStyle
            }
            ... on buttonGroup_Buttons_Phone_LinkType {
                buttonStyle
            }
            ... on buttonGroup_Buttons_Email_LinkType {
                buttonStyle
            }
        }
    }
`